import React, { useEffect, useState } from "react";
import CandidateInformation from "./CandidateInformation";
import PositionDetails from "./PositionDetails";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  getAllMasterDataBranchAction,
  getMasterDataQualificationModuleAction,
  getMasterDataSkillsModuleAction,
  getMasterDataUsersDepartmentAction,
  resetQualificationMasterDataList,
  resetQualificationMasterDataTotalCount,
  resetSkillMasterDataList,
  resetSkillsMasterDataTotalCount,
  resetUserDepartmentList,
  resetUserDepartmentTotalCount,
} from "../../../../redux/masterData";
import {
  CheckUniquiEmailAndMobilePayloadType,
  GetAllFinacUserPayloadType,
} from "../../../../commonTypes/authTypes";
import {
  checkRecruitmentTrackerUniqueEmailAction,
  checkRecruitmentTrackerUniqueMobileNoAction,
  checkUniqueEmailAction,
  getAllFinacUsersAction,
  resetEmailFetching,
  resetEmailMessage,
  resetFinacClientUsersList,
  resetRecruitmentTrackerUniqueEmailMessage,
  resetRecruitmentTrackerUniqueMobileMessage,
  resetSession,
} from "../../../../redux/auth";
import {
  GetAllMasterDataBranchPayloadType,
  GetMasterDataListPayloadType,
  GetUsersDepartmentPayloadType,
} from "../../../../commonTypes/masterDataTypes";
import {
  LoginResponseType,
  UserProfileType,
} from "../../../../redux/auth/authTypes";
import InterViewDetails from "./InterViewDetails";
import SalaryDetails from "./SalaryDetails";
import { ErrorSuccessModal, Loader, UploadModal } from "../../../commons";
import { useLocation } from "react-router-dom";
import OtherDetails from "./OtherDetails";
import {
  getApprovalListAction,
  getRecruitmentModuleOpenPositionAction,
  resetApprovalList,
  resetHrmsError,
  resetHrmsMessage,
  resetHrmsSuccess,
  resetRecruitmentTrackerList,
} from "../../../../redux/hrms";
import toast from "react-hot-toast";
import {
  ApprovalListPayloadType,
  RecruitmentCandidateDetailsType,
} from "../../../../commonTypes/hrmsTypes";
import {
  convertPasswordToHash,
  formatDate,
  formateDateAndTime,
  isEmailValid,
  isStcoEmailValid,
} from "../../../../utils/commonFunctions";
import {
  ImageDataType,
  SingleUploadImageDataType,
} from "../../../../commonTypes/fileManagerTypes";
import useDebounce from "../../../../customHooks/useDebounce";
import ConfirmAllUserModal from "../ConfirmAllUserModal";
import { addUserPofile } from "../../../../redux/usersProfile/actions";
import moment from "moment";
import { ProgressDropDown } from "../../../../constant/hrms/recruitmentModule/recruitmentTrackerDropdown";
import ApprovalsDeatils from "./ApprovalsDeatils";
import { ApprovalListType } from "../../../../redux/hrms/hrmsTypes";
import SendApprovalModal from "../SendApprovalModal";
import { DropDownType } from "../../../../commonTypes/clientDirectoryTypes";
import {
  QualificationMasterDataListType,
  skillMasterDataListType,
} from "../../../../redux/masterData/masterTypes";
import { GENDER_STATUS } from "../../../../constant/userProfileConstant";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import SingleUploadWithApi from "../../../commons/Upload/SingleUploadWithApi";
import { MulitpleFileUploadData } from "../../../../redux/clientSettings/clientSettingTypes";
import {
  resetMultipleFileUploadData,
  resetMultipleFileUploadError,
  resetMultipleFileUploadFetching,
  resetMultipleFileUploadSuccess,
} from "../../../../redux/clientSettings";
import SinglePreviewWithApi from "../../../commons/Upload/SinglePreviewWithApi";
export type InputDetailsErrorType = {
  nameError: string;
  companyNameError: string;
  phoneNumberError: string;
  emailError: string;
  yearsOfExperienceError: string;
  currentTotalCtcError: string;
  currentFixedCtcError: string;
  minExpectedTotalCtcError: string;
  minExpectedFixedCtcError: string;
  referredByError: string;
  sourcesError: string;
  meetingLinkError: string;
  applicationDateError: string;
  phoneScreeningDateAndTimeError: string;
  phoneScreenerError: string;
  noticePeriodError: string;
  jobprogressError: string;
  jobLocationError: string;
  jobPositionError: string;
  stcoEmailError: string;
};
type AppProps = {
  token: string | null;
  finacUser: any;
  success: number | null;
  statusCode: number | null;
  hrmsMessage: string | null;
  hrmsSuccess: number | null;
  masterDataSuccess: number | null;
  masterDataStatusCode: number | null;
  userFetching: boolean;
  branchFetching: boolean;
  // error: string | null;
  // history: any;

  branchDataList: any;
  totalUserCount: number | string;
  masterDataBranchListTotal: string | number;
  loginData: LoginResponseType;
  fetching: boolean;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetAllMasterDataBranchListAction: (
    data: GetAllMasterDataBranchPayloadType
  ) => void;
  dispatchResetFinacClientUsersList: () => void;
  handleRecruitmentTrackerSubmit?: (data: any) => void;
  handleGoBack?: () => void;
  jobPositionFetching: boolean;
  openPoisitionList: any;
  openPositionTotalCount: number;
  singleRecruitmentTrackerList?: any;
  dispatchGetRecruitmentModuleOpenPositionAction: (data: any) => void;
  dispatchResetRecruitmentTrackerList: () => void;
  dispatchResetSession: () => void;
  dispatchResetHrmsSuccess: () => void;
  dispatchResetHrmsMessage: () => void;
  dispatchResetHrmsError: () => void;
  emailFetching: boolean;
  dispatchResetEmailFetching: () => void;
  dispatchResetRecruitmentTrackerUniqueMobileMessage: () => void;
  dispatchResetRecruitmentTrackerUniqueEmailMessage: () => void;
  isEmail: number | null;
  emailMessage: string | null;
  qualificationMasterDataList: QualificationMasterDataListType[] | [];
  skillMasterDataList: skillMasterDataListType[] | [];
  skillsMasterDataTotalCount: number;
  qualificationMasterDataTotalCount: number;
  dispatchResetEmailMessage: () => void;
  dispatchCheckUniqueEmailAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => void;
  dispatcCheckRecruitmentTrackerUniqueEmailAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => void;
  dispatchCheckRecruitmentTrackerUniqueMobileNoAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => void;
  dispatchAddUser: (data: any) => void;
  activeTab: string;
  recruitmentTrackerUniqueEmailFetching: boolean;
  recruitmentTrackerUniqueEmailMessage: string | null;
  recruitmentTrackerUniqueMobileFetching: boolean;
  recruitmentTrackerUniqueMobileMessage: string | null;
  dispatchApprovalListAction: (data: ApprovalListPayloadType) => void;
  approvalList: ApprovalListType[] | [];
  userDepartmentList: any[] | [];
  userDepartmentTotalCount: number;
  dispatchResetApprovalList: () => void;
  hrmsId?: string;
  dispatchGetMasterDataSkillsModuleAction: (
    data: GetMasterDataListPayloadType
  ) => void;
  dispatchResetSkillMasterDataList: () => void;
  dispatchResetSkillsMasterDataTotalCount: () => void;
  dispatchGetMasterDataQualificationModuleAction: (
    data: GetMasterDataListPayloadType
  ) => void;
  dispatchResetQualificationMasterDataList: () => void;
  dispatchResetQualificationMasterDataTotalCount: () => void;
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => void;
  dispatchResetUserDepartmentList: () => void;
  dispatchResetresetUserDepartmentTotalCount: () => void;
  fileUploadData: MulitpleFileUploadData[] | [];
  dispatchResetFileUploadFetching: () => void;
  dispatchResetFileUploadData: () => void;
  dispatchResetFileUploadSuccess: () => void;
  dispatchResetFileUploadError: () => void;
};
const interviewAddMoreDetailsInput = [
  {
    interviewDateAndTime: null,
    interviewers: {
      value: null,
      label: "Select..",
    },
    interviewFeedback: "",
    interviewDateAndTimeError: "",
    interviewersError: "",
  },
];
const CandidateApplicationForm = ({
  token,
  finacUser,
  success,
  statusCode,
  masterDataSuccess,
  masterDataStatusCode,
  userFetching,
  branchFetching,
  branchDataList,
  masterDataBranchListTotal,
  loginData,
  fetching,
  totalUserCount,
  // history,
  // error,
  dispatchGetAllFinacUsersAction,
  dispatchGetAllMasterDataBranchListAction,
  dispatchResetFinacClientUsersList,
  handleRecruitmentTrackerSubmit,
  handleGoBack,
  openPoisitionList,
  openPositionTotalCount,
  jobPositionFetching,
  dispatchGetRecruitmentModuleOpenPositionAction,
  singleRecruitmentTrackerList,
  dispatchResetRecruitmentTrackerList,
  dispatchResetSession,
  dispatchResetHrmsSuccess,
  dispatchResetHrmsMessage,
  dispatchResetHrmsError,
  emailFetching,
  dispatchResetEmailFetching,
  isEmail,
  emailMessage,
  dispatchResetEmailMessage,
  dispatchCheckUniqueEmailAction,
  dispatcCheckRecruitmentTrackerUniqueEmailAction,
  dispatchCheckRecruitmentTrackerUniqueMobileNoAction,
  dispatchAddUser,
  recruitmentTrackerUniqueEmailFetching,
  recruitmentTrackerUniqueEmailMessage,
  recruitmentTrackerUniqueMobileFetching,
  recruitmentTrackerUniqueMobileMessage,
  activeTab,
  dispatchResetRecruitmentTrackerUniqueMobileMessage,
  dispatchResetRecruitmentTrackerUniqueEmailMessage,
  dispatchApprovalListAction,
  approvalList,
  hrmsSuccess,
  hrmsMessage,
  dispatchResetApprovalList,
  hrmsId,
  dispatchGetMasterDataSkillsModuleAction,
  dispatchResetSkillMasterDataList,
  dispatchResetSkillsMasterDataTotalCount,
  dispatchGetMasterDataQualificationModuleAction,
  dispatchResetQualificationMasterDataList,
  dispatchResetQualificationMasterDataTotalCount,
  qualificationMasterDataList,
  skillMasterDataList,
  skillsMasterDataTotalCount,
  qualificationMasterDataTotalCount,
  userDepartmentList,
  userDepartmentTotalCount,
  dispatchGetMasterDataUsersDepartmentAction,
  dispatchResetUserDepartmentList,
  dispatchResetresetUserDepartmentTotalCount,
  fileUploadData,
  dispatchResetFileUploadFetching,
  dispatchResetFileUploadData,
  dispatchResetFileUploadSuccess,
  dispatchResetFileUploadError,
}: AppProps) => {
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [showResumeUploadModal, setShowResumeUploadModal] =
    useState<boolean>(false);
  const [previewData, setPreviewData] = useState<SingleUploadImageDataType>({
    fileUrl: "",
    fileType: "",
    finalFileName: "",
  });
  const { pathname } = useLocation();
  const [sendApprovalsModal, setSendApprovalsModal] = useState(false);
  const isEdit = singleRecruitmentTrackerList ? true : false;
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [finalBranchDataList, setFinalBranchDataList] = useState<any>([]);
  const [finalJobPositionList, setFinalJobPositionList] = useState<any>([]);
  const [finalSkillList, setFinalSkillList] = useState<DropDownType[] | []>([]);
  const [finalQualificationList, setFinalQualificationList] = useState<
    DropDownType[] | []
  >([]);
  const [finalReferedByList, setFinalReferedByList] = useState<any>([]);
  const [referedByText, setReferedByText] = useState<string>("");
  const [referedByLimit, setReferedByLimit] = useState<number>(20);
  const [referedByOffset, setReferedByOffset] = useState<number>(0);
  const [jobPositionOffset, setJobPositionOffset] = useState<number>(0);
  const [jobPositionText, setJobPositionText] = useState<string>("");
  const [skillsOffset, setSkillsOffset] = useState<number>(0);
  const [skillsText, setSkillsText] = useState<string>("");
  const [qualificationOffset, setQualificationOffset] = useState<number>(0);
  const [qualificationText, setQualificationText] = useState<string>("");
  const [branchText, setBranchText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [branchOffset, setBranchOffset] = useState<number>(0);
  const [finalRecruiterList, setFinalRecruiterList] = useState<any>([]);
  const [finalDepartmentList, setFinalDepartmentList] = useState<
    DropDownType[] | []
  >([]);
  const [departmentOffset, setDepartmentOffset] = useState<number>(0);
  const [departmentText, setDepartmentText] = useState<string>("");
  const [recruiterText, setRecruiterText] = useState<string>("");
  const [recruiterLimit, setRecruiterLimit] = useState<number>(20);
  const [recruiterOffset, setRecruiterOffset] = useState<number>(0);
  const [confirmedAllUsers, setConfirmedAllUsers] = useState<boolean>(false);
  const [allUsersPassword, setAllUsersPassword] = useState<string>("");
  const [isPendingHRMSInterviewApprovals, setIsPendingHRMSInterviewApprovals] =
    useMenuCheck("hrms");
  const [inputDetailsError, setInputDetailsError] =
    useState<InputDetailsErrorType>({
      nameError: "",
      companyNameError: "",
      phoneNumberError: "",
      emailError: "",
      yearsOfExperienceError: "",
      currentTotalCtcError: "",
      currentFixedCtcError: "",
      minExpectedTotalCtcError: "",
      minExpectedFixedCtcError: "",
      referredByError: "",
      sourcesError: "",
      meetingLinkError: "",
      applicationDateError: "",
      phoneScreeningDateAndTimeError: "",
      phoneScreenerError: "",
      noticePeriodError: "",
      jobprogressError: "",
      jobLocationError: "",
      jobPositionError: "",
      stcoEmailError: "",
    });
  const [candidateDetails, setCandidateDetails] =
    useState<RecruitmentCandidateDetailsType>({
      applicantDetails: {
        profile_pic: null,
        name: "",
        email: "",
        phoneNumber: "",
        yearsOfExperience: "",
        linkedinProfile: "",
        noticePeriod: "",
        resume: {},
        gender: { label: "Select", value: null },
        skill: [],
        qualification: [],
      },
      uniqueId: "",
      positionDetails: {
        jobPosition: {
          value: null,
          label: "Select..",
        },
        jobLocation: {
          value: null,
          label: "Select..",
        },
        progress: {
          value: ProgressDropDown[0],
          label: "New Application",
        },
        recruiter: {
          value: null,
          label: "Select..",
        },
        offeredJobPosition: {
          value: null,
          label: "Select...",
        },
        proposedJoiningDate: null,
      },
      interviewDetails: {
        applicationDate: moment().format("YYYY-MM-DD"),
        phoneScreeningDateAndTime: null,
        phoneScreener: {
          value: null,
          label: "Select..",
        },
        interviewFeedback: "",
        interviewInputDetails: [],
      },
      salary_details: {
        currentTotalCtc: "",
        current_fixed_ctc: "",
        min_expected_total_ctc: "",
        min_expected_fixed_ctc: "",
        offered_annual_ctc: "",
        offered_fixed_annual_ctc: "",
      },
      otherDetails: {
        referredBy: {
          value: null,
          label: "Select..",
        },
        sources: {
          value: null,
          label: "Select..",
        },
        meetingLink: "",
      },
      is_user_created: false,
    });
  const [allUserDataForm, setAllUserDataForm] = useState<UserProfileType>({
    type: "employee",
    user_details: {
      profile_pic: null,
      basic_details: {
        first_name: "",
        last_name: "",
        email_id: "",
        access_details: {
          status: "",
          assigned_group: null,
          password: "",
        },
        skill: [],
      },
      personal_details: {
        gender: "",
        date_of_birth: "",
        blood_group: "",
        qualifications: "",
        mother_name: "",
        martial_status: "",
        spouse_name: "",
        father_or_husband_name: "",
        about_me: "",
      },
      current_address: {
        address_line1: "",
        address_line2: "",
        city: {
          value: null,
          label: "Select",
        },
        state: {
          value: null,
          label: "Select",
        },
        postal_code: "",
        country: {
          value: null,
          label: "Select",
        },
      },
      permanent_address: {
        address_line1: "",
        address_line2: "",
        city: {
          value: null,
          label: "Select",
        },
        state: {
          value: null,
          label: "Select",
        },
        postal_code: "",
        country: {
          value: null,
          label: "Select",
        },
      },
      contact_details: {
        personal_email_id: "",
        mobile: "",
        whatsapp_number: "",
        work_phone: "",
        emergency_contact_person: "",
        emergency_contact_number: "",
      },
      online_presence: {
        twitter_id: "",
        linkedin_profile: "",
      },
    },
    hr_settings: {
      leave_balance: null,
      work_from_home_balance: null,
      working_days: null,
      employment_status: "",
      is_govt_officer: false,
      work_details: {
        user_branch: null,
        // hourly_charge: "",
        // standard_hour: "",
        is_partner_field: false,
        is_manager_field: false,
        is_track_scheduling: false,
        is_track_efficiency: false,
      },
    },
    job_details: [],
    payroll_settings: {
      identification_details: {
        passport_number: "",
        passport_expiry: "",
        adhar_number: "",
        pan: "",
        uan_number: "",
        entity_name: "",
      },
      bank_account_details: [
        {
          bank_name: "",
          branch_name: "",
          bank_account_number: "",
          ifsc_code: "",
          account_type: "",
        },
      ],
      hourly_charge: "",
      standard_hour: "",
    },
  });
  const [interviewerInputDetails, setInterviewerInputDetails] = useState<any>(
    JSON.parse(JSON.stringify(interviewAddMoreDetailsInput))
  );

  useEffect(() => {
    dispatchResetEmailFetching();
    dispatchResetEmailMessage();
    dispatchResetRecruitmentTrackerUniqueMobileMessage();
    dispatchResetRecruitmentTrackerUniqueEmailMessage();
    dispatchResetApprovalList();
    dispatchResetHrmsSuccess();
    dispatchResetHrmsMessage();
    dispatchResetSkillMasterDataList();
    dispatchResetSkillsMasterDataTotalCount();
    dispatchResetQualificationMasterDataList();
    dispatchResetQualificationMasterDataTotalCount();
    setIsPendingHRMSInterviewApprovals(
      "Pending HRMS Interview Approvals",
      "menu"
    );
    dispatchResetFileUploadFetching();
    dispatchResetFileUploadData();
    dispatchResetFileUploadSuccess();
    dispatchResetFileUploadError();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const passwordData = await convertPasswordToHash("123NewUser@");
        setAllUsersPassword(passwordData);
      } catch (error) { }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (token && isEdit && hrmsId && isPendingHRMSInterviewApprovals) {
      const finaData = {
        hrms_id: hrmsId,
        token,
        sort_by: "approved_at",
        sorting_order: "asc",
        type: "hrms",
      };
      dispatchApprovalListAction(finaData);
    }
  }, [isPendingHRMSInterviewApprovals]);

  useEffect(() => {
    if (confirmedAllUsers) {
      const skillIds = candidateDetails?.applicantDetails?.skill.map(
        (skill: any) => skill.value
      );
      setAllUserDataForm((prv: UserProfileType) => ({
        ...prv,
        user_details: {
          ...prv.user_details,
          profile_pic: candidateDetails?.applicantDetails?.profile_pic,
          basic_details: {
            ...prv?.user_details?.basic_details,
            first_name: candidateDetails?.applicantDetails?.name,
            last_name: "",
            access_details: {
              ...prv?.user_details?.basic_details?.access_details,
              status: "1",
              password: allUsersPassword,
            },
            skill: skillIds,
          },
          contact_details: {
            ...prv?.user_details?.contact_details,
            personal_email_id: candidateDetails?.applicantDetails?.email,
          },
          online_presence: {
            ...prv?.user_details?.online_presence,
            linkedin_profile:
              candidateDetails?.applicantDetails?.linkedinProfile,
          },
        },
        hr_settings: {
          ...prv.hr_settings,
          work_details: {
            ...prv.hr_settings?.work_details,
            user_branch: candidateDetails?.positionDetails?.jobLocation?.label,
          },
        },
      }));
    }
  }, [confirmedAllUsers, allUsersPassword]);

  //   branch dropdown
  useEffect(() => {
    const branchData = branchDataList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.branch_name,
      };
    });
    if (branchOffset > 0) {
      setFinalBranchDataList([...finalBranchDataList, ...branchData]);
    } else {
      setFinalBranchDataList(branchData);
    }
  }, [branchDataList]);
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: branchOffset,
        limit,
        search_term: branchText,
        branch_status: 1,
      };
      if (branchOffset <= +masterDataBranchListTotal) {
        dispatchGetAllMasterDataBranchListAction(finalUserData);
      }
    }
  }, [branchOffset]);

  const fetchNewBranchData = (search: string) => {
    const finalData = {
      token,
      offset: branchOffset,
      limit,
      search_term: branchText,
      branch_status: 1,
    };
    dispatchGetAllMasterDataBranchListAction(finalData);
  };

  useDebounce(
    () => {
      if (branchText) {
        fetchNewBranchData(branchText);
      } else {
        const finalData = {
          token,
          offset: branchOffset,
          limit,
          search_term: branchText,
          branch_status: 1,
        };
        dispatchGetAllMasterDataBranchListAction(finalData);
      }
    },
    500,
    [branchText]
  );

  //job position
  useEffect(() => {
    const jobData = openPoisitionList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.position_name,
      };
    });
    if (jobPositionOffset > 0) {
      setFinalJobPositionList([...finalJobPositionList, ...jobData]);
    } else {
      setFinalJobPositionList(jobData);
    }
  }, [openPoisitionList]);

  //skills
  useEffect(() => {
    const skillsData = skillMasterDataList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.skill_name,
      };
    });
    if (skillsOffset > 0) {
      setFinalSkillList([...finalSkillList, ...skillsData]);
    } else {
      setFinalSkillList(skillsData);
    }
  }, [skillMasterDataList]);

  //qualification
  useEffect(() => {
    const qualificationData = qualificationMasterDataList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.qualification_name,
      };
    });
    if (qualificationOffset > 0) {
      setFinalQualificationList([
        ...finalQualificationList,
        ...qualificationData,
      ]);
    } else {
      setFinalQualificationList(qualificationData);
    }
  }, [qualificationMasterDataList]);

  //department

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: departmentOffset,
        limit,
        status: 1,
        searchValue: departmentText,
      };
      if (departmentOffset <= +userDepartmentTotalCount) {
        dispatchGetMasterDataUsersDepartmentAction(finalUserData);
      }
    }
  }, [departmentOffset]);

  const fetchNewDepartmentData = (search: string) => {
    const finalData = {
      token,
      offset: 0,
      limit: 20,
      status: 1,
      searchValue: departmentText,
    };
    dispatchGetMasterDataUsersDepartmentAction(finalData);
  };

  useDebounce(
    () => {
      if (departmentText) {
        setDepartmentOffset(0);
        fetchNewDepartmentData(departmentText);
      } else {
        const finalData = {
          token,
          offset: 0,
          limit,
          status: 1,
          searchValue: "",
        };
        dispatchGetMasterDataUsersDepartmentAction(finalData);
      }
    },
    500,
    [departmentText]
  );

  useEffect(() => {
    const departmentList = userDepartmentList?.map((data: any) => {
      return {
        value: data?._id,
        label: data?.department_name,
      };
    });
    if (departmentOffset > 0) {
      setFinalDepartmentList([...finalDepartmentList, ...departmentList]);
    } else {
      setFinalDepartmentList(departmentList);
    }
  }, [userDepartmentList]);

  // skills
  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        searchValue: skillsText,
        limit,
        offset: skillsOffset,
        status: 1,
      };
      if (skillsOffset <= +skillsMasterDataTotalCount) {
        dispatchGetMasterDataSkillsModuleAction(finalData);
      }
    }
  }, [skillsOffset]);

  const fetchNewSkillsData = (search: string) => {
    let finalData = {
      token,
      searchValue: skillsText,
      limit,
      offset: skillsOffset,
      status: 1,
    };
    dispatchGetMasterDataSkillsModuleAction(finalData);
  };

  useDebounce(
    () => {
      if (skillsText) {
        fetchNewSkillsData(skillsText);
      } else {
        let finalData = {
          token,
          searchValue: skillsText,
          limit,
          offset: skillsOffset,
          status: 1,
        };
        dispatchGetMasterDataSkillsModuleAction(finalData);
      }
    },
    500,
    [skillsText]
  );

  //qualification

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        searchValue: qualificationText,
        limit,
        offset: qualificationOffset,
      };
      if (qualificationOffset <= +qualificationMasterDataTotalCount) {
        dispatchGetMasterDataQualificationModuleAction(finalData);
      }
    }
  }, [qualificationOffset]);

  const fetchNewQualificationData = (search: string) => {
    let finalData = {
      token,
      searchValue: qualificationText,
      limit,
      offset: qualificationOffset,
    };
    dispatchGetMasterDataQualificationModuleAction(finalData);
  };

  useDebounce(
    () => {
      if (qualificationText) {
        fetchNewQualificationData(qualificationText);
      } else {
        let finalData = {
          token,
          searchValue: qualificationText,
          limit,
          offset: qualificationOffset,
        };
        dispatchGetMasterDataQualificationModuleAction(finalData);
      }
    },
    500,
    [qualificationText]
  );

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: jobPositionOffset,
        limit,
        search_term: jobPositionText,
        status: 1,
      };
      if (jobPositionOffset <= +openPositionTotalCount) {
        dispatchGetRecruitmentModuleOpenPositionAction(finalUserData);
      }
    }
  }, [jobPositionOffset]);

  const fetchNewPositionData = (search: string) => {
    const finalData = {
      token,
      offset: jobPositionOffset,
      limit,
      search_term: jobPositionText,
      status: 1,
    };
    dispatchGetRecruitmentModuleOpenPositionAction(finalData);
  };

  useDebounce(
    () => {
      if (jobPositionText) {
        fetchNewPositionData(jobPositionText);
      } else {
        const finalData = {
          token,
          offset: jobPositionOffset,
          limit,
          search_term: jobPositionText,
          status: 1,
        };
        dispatchGetRecruitmentModuleOpenPositionAction(finalData);
      }
    },
    500,
    [jobPositionText]
  );

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""
          }%${user?.job_title ? user?.job_title : ""} ${user?.department ? "|" : ""
          } ${user?.department !== null ? user?.department : ""}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (recruiterOffset > 0) {
      setFinalRecruiterList([...finalRecruiterList, ...finalUserData]);
    } else {
      setFinalRecruiterList(finalUserData);
    }
  }, [finacUser]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: recruiterOffset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: recruiterText,
      };
      if (recruiterOffset <= +totalUserCount) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [recruiterOffset]);

  const fetchNewRecruiterData = (search: string) => {
    const finalData = {
      token,
      offset: recruiterOffset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: recruiterText,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useDebounce(
    () => {
      if (recruiterText) {
        fetchNewRecruiterData(recruiterText);
      } else {
        const finalData = {
          token,
          offset: recruiterOffset,
          limit,
          user_type: "stco_users",
          status: 1,
          search_term: recruiterText,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [recruiterText]
  );

  // refered by
  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${user?.last_name ? user?.last_name : ""
          }%${user?.job_title ? user?.job_title : ""} ${user?.department ? "|" : ""
          } ${user?.department !== null ? user?.department : ""}`,
        image: user?.profile_pic?.file_url,
      };
    });
    if (referedByOffset > 0) {
      setFinalReferedByList([...finalReferedByList, ...finalUserData]);
    } else {
      setFinalReferedByList(finalUserData);
    }
  }, [finacUser]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: referedByOffset,
        limit: referedByLimit,
        user_type: "stco_users",
        status: 1,
        search_term: referedByText,
      };
      if (referedByOffset <= +totalUserCount) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [referedByOffset]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset: referedByOffset,
      limit: referedByLimit,
      user_type: "stco_users",
      status: 1,
      search_term: referedByText,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useDebounce(
    () => {
      if (referedByText) {
        fetchNewData(referedByText);
      } else {
        const finalData = {
          token,
          offset: referedByOffset,
          limit: referedByLimit,
          user_type: "stco_users",
          status: 1,
          search_term: referedByText,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [referedByText]
  );

  useEffect(() => {
    setCandidateDetails((prev: any) => ({
      ...prev,
      interviewDetails: {
        ...prev.interviewDetails,
        interviewInputDetails: [...interviewerInputDetails],
      },
    }));
  }, [interviewerInputDetails]);
  useEffect(() => {
    if (singleRecruitmentTrackerList) {
      if (
        singleRecruitmentTrackerList?.interview_details?.interview_round_details
      ) {
        let arr: any = [];
        singleRecruitmentTrackerList?.interview_details?.interview_round_details?.map(
          (data: any) => {
            arr.push({
              interviewers: {
                value: data?.interviewer?.user_id,
                label: data?.interviewer?.first_name
                  ? `${data?.interviewer?.first_name} ${data?.interviewer?.last_name
                    ? data?.interviewer?.last_name
                    : ""
                  }`
                  : "Select..",
              },
              interviewDateAndTime: data?.interview_date_and_time
                ? formateDateAndTime(data?.interview_date_and_time)
                : null,
              interviewFeedback: data?.interview_feedback,
              is_feedback_submited: data?.is_feedback_submited,
              level: data?.level,
            });
          }
        );
        setInterviewerInputDetails(arr);
      } else {
        setInterviewerInputDetails(
          JSON.parse(JSON.stringify(interviewAddMoreDetailsInput))
        );
      }
      setCandidateDetails((prev: any) => {
        let finalSkills: DropDownType[] | [] =
          singleRecruitmentTrackerList?.applicant_details?.skill?.map(
            (item: any) => {
              return {
                label: item?.skill_name,
                value: item?._id,
              };
            }
          );

        let finalQualification: DropDownType[] | [] =
          singleRecruitmentTrackerList?.applicant_details?.qualification?.map(
            (item: any) => {
              return {
                label: item?.qualification_name,
                value: item?._id,
              };
            }
          );
        return {
          ...prev,
          is_user_created: singleRecruitmentTrackerList?.is_user_created,
          applicantDetails: {
            profile_pic: singleRecruitmentTrackerList?.applicant_details
              ?.profile_pic
              ? singleRecruitmentTrackerList?.applicant_details?.profile_pic
              : null,
            name: singleRecruitmentTrackerList?.applicant_details?.name,
            email: singleRecruitmentTrackerList?.applicant_details?.email,
            phoneNumber:
              singleRecruitmentTrackerList?.applicant_details?.phone_number,
            yearsOfExperience: singleRecruitmentTrackerList?.applicant_details
              ?.years_of_experience
              ? singleRecruitmentTrackerList?.applicant_details
                ?.years_of_experience
              : "0",
            linkedinProfile:
              singleRecruitmentTrackerList?.applicant_details?.linkedin_profile,
            noticePeriod: singleRecruitmentTrackerList?.applicant_details
              ?.notice_period
              ? singleRecruitmentTrackerList?.applicant_details?.notice_period
              : "",
            resume:
              singleRecruitmentTrackerList?.applicant_details?.resume_upload,
            skill: finalSkills,
            qualification: finalQualification,
            gender: GENDER_STATUS?.find(
              (singleGender: DropDownType) =>
                singleGender.value ==
                singleRecruitmentTrackerList?.applicant_details?.gender
            ),
          },
          uniqueId: singleRecruitmentTrackerList?.unique_id,
          positionDetails: {
            department: {
              value:
              singleRecruitmentTrackerList?.position_details?.department&&
                Object?.keys(
                  singleRecruitmentTrackerList?.position_details?.department
                )?.length > 0
                  ? singleRecruitmentTrackerList?.position_details?.department
                    ?.id
                  : null,
              label:
              singleRecruitmentTrackerList?.position_details?.department &&
                Object?.keys(
                  singleRecruitmentTrackerList?.position_details?.department
                )?.length > 0
                  ? singleRecruitmentTrackerList?.position_details?.department
                    ?.name
                  : "Select..",
            },
            jobPosition: {
              value:
              singleRecruitmentTrackerList?.position_details?.job_position&&
                Object.keys(
                  singleRecruitmentTrackerList?.position_details?.job_position
                )?.length > 0
                  ? singleRecruitmentTrackerList?.position_details?.job_position
                    ?.id
                  : null,
              label:
              singleRecruitmentTrackerList?.position_details?.job_position &&
                Object.keys(
                  singleRecruitmentTrackerList?.position_details?.job_position
                )?.length > 0
                  ? singleRecruitmentTrackerList?.position_details?.job_position
                    ?.name
                  : "Select..",
            },
            offeredJobPosition: {
              value:
              singleRecruitmentTrackerList?.position_details
              ?.offered_job_position &&
                Object.keys(
                  singleRecruitmentTrackerList?.position_details
                    ?.offered_job_position
                )?.length > 0
                  ? singleRecruitmentTrackerList?.position_details
                    ?.offered_job_position?.id
                  : null,
              label:
              singleRecruitmentTrackerList?.position_details
              ?.offered_job_position &&
                Object.keys(
                  singleRecruitmentTrackerList?.position_details
                    ?.offered_job_position
                )?.length > 0
                  ? singleRecruitmentTrackerList?.position_details
                    ?.offered_job_position?.name
                  : "Select..",
            },
            jobLocation: {
              value: singleRecruitmentTrackerList?.position_details
                ?.job_location
                ? singleRecruitmentTrackerList?.position_details?.job_location
                  ?.id
                : null,
              label: singleRecruitmentTrackerList?.position_details
                ?.job_location
                ? singleRecruitmentTrackerList?.position_details?.job_location
                  ?.name
                : "Select..",
            },
            progress: {
              value: singleRecruitmentTrackerList?.position_details?.progress
                ? singleRecruitmentTrackerList?.position_details?.progress
                : null,
              label: singleRecruitmentTrackerList?.position_details?.progress
                ? singleRecruitmentTrackerList?.position_details?.progress
                : "Select..",
            },
            recruiter: {
              value: singleRecruitmentTrackerList?.position_details?.recruiter
                ? singleRecruitmentTrackerList?.position_details?.recruiter
                  ?.user_id
                : null,
              label: singleRecruitmentTrackerList?.position_details?.recruiter
                ?.user_id
                ? `${singleRecruitmentTrackerList?.position_details?.recruiter
                  ?.first_name
                } ${singleRecruitmentTrackerList?.position_details?.recruiter
                  ?.last_name
                  ? singleRecruitmentTrackerList?.position_details
                    ?.recruiter?.last_name
                  : ""
                }`
                : "Select..",
            },
            proposedJoiningDate: singleRecruitmentTrackerList?.position_details
              ?.proposed_joining_date
              ? formatDate(
                singleRecruitmentTrackerList?.position_details
                  ?.proposed_joining_date
              )
              : null,
          },
          interviewDetails: {
            applicationDate: singleRecruitmentTrackerList?.interview_details
              ?.application_date
              ? singleRecruitmentTrackerList?.interview_details
                ?.application_date
              : null,
            phoneScreeningDateAndTime: singleRecruitmentTrackerList
              ?.interview_details?.screening_details
              ?.phone_screening_date_and_time
              ? formateDateAndTime(
                singleRecruitmentTrackerList?.interview_details
                  ?.screening_details?.phone_screening_date_and_time
              )
              : null,
            interviewFeedback:
              singleRecruitmentTrackerList?.interview_details?.screening_details
                ?.screening_feedback,
            phoneScreener: {
              value:
                singleRecruitmentTrackerList?.interview_details
                  ?.screening_details?.phone_screener?.user_id,
              label: singleRecruitmentTrackerList?.interview_details
                ?.screening_details?.phone_screener?.first_name
                ? singleRecruitmentTrackerList?.interview_details
                  ?.screening_details?.phone_screener?.first_name
                : "" +
                  " " +
                  singleRecruitmentTrackerList?.interview_details
                    ?.screening_details?.phone_screener?.last_name
                  ? singleRecruitmentTrackerList?.interview_details
                    ?.screening_details?.phone_screener?.last_name
                  : "",
            },
          },
          salary_details: {
            currentTotalCtc: singleRecruitmentTrackerList?.salary_details
              ?.current_total_ctc
              ? singleRecruitmentTrackerList?.salary_details?.current_total_ctc
              : "0",
            current_fixed_ctc: singleRecruitmentTrackerList?.salary_details
              ?.current_fixed_ctc
              ? singleRecruitmentTrackerList?.salary_details?.current_fixed_ctc
              : "0",
            min_expected_total_ctc: singleRecruitmentTrackerList?.salary_details
              ?.min_expected_total_ctc
              ? singleRecruitmentTrackerList?.salary_details
                ?.min_expected_total_ctc
              : "0",
            min_expected_fixed_ctc: singleRecruitmentTrackerList?.salary_details
              ?.min_expected_fixed_ctc
              ? singleRecruitmentTrackerList?.salary_details
                ?.min_expected_fixed_ctc
              : "0",
            offered_annual_ctc: singleRecruitmentTrackerList?.salary_details
              ?.offered_ctc
              ? singleRecruitmentTrackerList?.salary_details?.offered_ctc
              : "0",
            offered_fixed_annual_ctc: singleRecruitmentTrackerList
              ?.salary_details?.offered_fixed_ctc
              ? singleRecruitmentTrackerList?.salary_details?.offered_fixed_ctc
              : "0",
          },
          otherDetails: {
            referredBy: {
              value:
                singleRecruitmentTrackerList?.other_details?.referred_by
                  ?.user_id,
              label: singleRecruitmentTrackerList?.other_details?.referred_by
                ?.first_name
                ? `
            ${singleRecruitmentTrackerList?.other_details?.referred_by
                  ?.first_name
                }
            ${singleRecruitmentTrackerList?.other_details?.referred_by
                  ?.last_name
                  ? singleRecruitmentTrackerList?.other_details?.referred_by
                    ?.last_name
                  : ""
                }
            `
                : "Select..",
            },
            sources: {
              value: singleRecruitmentTrackerList?.other_details?.sources
                ? singleRecruitmentTrackerList?.other_details?.sources
                : null,
              label: singleRecruitmentTrackerList?.other_details?.sources
                ? singleRecruitmentTrackerList?.other_details?.sources
                : "Select..",
            },
            meetingLink:
              singleRecruitmentTrackerList?.other_details?.meeting_link,
          },
        };
      });
    }
  }, [singleRecruitmentTrackerList]);

  useDebounce(
    () => {
      dispatchResetRecruitmentTrackerUniqueEmailMessage();
      if (candidateDetails?.applicantDetails?.email) {
        let finalData: any = {
          token,
          operation: isEdit ? "update" : "add",
          check_name: "email",
          value: candidateDetails?.applicantDetails?.email?.trim(),
          id: isEdit ? singleRecruitmentTrackerList?._id : "",
        };
        dispatcCheckRecruitmentTrackerUniqueEmailAction(finalData);
      }
    },
    500,
    [candidateDetails?.applicantDetails?.email]
  );
  useDebounce(
    () => {
      dispatchResetRecruitmentTrackerUniqueMobileMessage();
      if (candidateDetails?.applicantDetails?.phoneNumber) {
        let finalData: any = {
          token,
          check_name: "phone_number",
          value: candidateDetails?.applicantDetails?.phoneNumber,
          operation: isEdit ? "update" : "add",
          id: isEdit ? singleRecruitmentTrackerList?._id : "",
        };
        dispatchCheckRecruitmentTrackerUniqueMobileNoAction(finalData);
      }
    },
    500,
    [candidateDetails?.applicantDetails?.phoneNumber]
  );

  const handlePreviewImageModal = () => {
    setShowImagePreview(!showImagePreview);
  };

  const handleRecruiterDropdownChange = (e: any) => {
    setCandidateDetails((prev: any) => {
      return {
        ...prev,
        positionDetails: {
          ...prev.positionDetails,
          recruiter: {
            value: e?.value,
            label: e?.label?.split("%")[0],
          },
        },
      };
    });
    // }
  };
  const handleReferedByDropdownChange = (e: any) => {
    setCandidateDetails((prev: any) => {
      return {
        ...prev,
        otherDetails: {
          ...prev.otherDetails,
          referredBy: {
            value: e?.value,
            label: e?.label?.split("%")[0],
          },
        },
      };
    });
    // }
  };
  const handleOpenPreview = (data: any) => {
    setPreviewData({
      ...previewData,
      fileUrl: data?.file_url,
      fileType: data?.file_type,
      finalFileName: data?.file_name,
    });
    setShowImagePreview(!showImagePreview);
  };
  useEffect(() => {
    if (fileUploadData?.length != 0) {
      const data = fileUploadData?.[0];
      handleResumeUploadFile(data);
    } else {
      dispatchResetFileUploadData();
      setCandidateDetails((prevCandidateDetails) => ({
        ...prevCandidateDetails,
        applicantDetails: {
          ...prevCandidateDetails.applicantDetails,
          resume: {},
        },
      }));
    }
  }, [fileUploadData?.length]);
  const handleResumeUploadFile = (data: any) => {
    // setCandidateDetails
    setCandidateDetails((prevCandidateDetails) => ({
      ...prevCandidateDetails,
      applicantDetails: {
        ...prevCandidateDetails.applicantDetails,
        resume: data,
      },
    }));
    setShowResumeUploadModal(false);
  };
  const handleDeleteResume = () => {
    setCandidateDetails((prevCandidateDetails) => ({
      ...prevCandidateDetails,
      applicantDetails: {
        ...prevCandidateDetails.applicantDetails,
        resume: {},
      },
    }));
    dispatchResetFileUploadData();
  };
  const handleResumeToggleUploadModal = (e: any) => {
    e.preventDefault();
    setShowResumeUploadModal(!showResumeUploadModal);
  };
  const handleBasicDetailsInput = (
    data: any,
    section: string,
    name: string,
    type?: string
  ) => {
    if (type === "dropdown") {
      setCandidateDetails((prev: any) => {
        let updatedDetails = { ...prev };
        updatedDetails = {
          ...prev,
          applicantDetails: {
            ...prev.applicantDetails,
            [name]: data,
          },
        };
        return updatedDetails;
      });
    } else {
      setCandidateDetails((prev: any) => {
        let updatedDetails = { ...prev };

        if (section === "applicantDetails") {
          updatedDetails = {
            ...prev,
            applicantDetails: {
              ...prev.applicantDetails,
              [data.target.name]: data.target.value,
            },
          };
        } else if (section === "salaryDetails") {
          updatedDetails = {
            ...prev,
            salary_details: {
              ...prev.salary_details,
              [data.target.name]: data.target.value,
            },
          };
        } else if (section === "otherDetails") {
          updatedDetails = {
            ...prev,
            otherDetails: {
              ...prev.otherDetails,
              [data.target.name]: data.target.value,
            },
          };
        }

        return updatedDetails;
      });
    }
    setInputDetailsError((prevErrors) => ({
      ...prevErrors,
      [`${name}Error`]: "",
    }));
  };

  const handleBranceDetailsChange = (data: any) => {
    setInputDetailsError((prevErrors) => ({
      ...prevErrors,
      jobLocationError: "",
    }));
    setCandidateDetails((prev: any) => {
      return {
        ...prev,
        positionDetails: {
          ...prev.positionDetails,
          jobLocation: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };

  const handleJobPositionChange = (data: any) => {
    setInputDetailsError((prevErrors) => ({
      ...prevErrors,
      jobPositionError: "",
    }));
    setCandidateDetails((prev: any) => {
      return {
        ...prev,
        positionDetails: {
          ...prev.positionDetails,
          jobPosition: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };

  const handleOfferedJobPosition = (data: any) => {
    setCandidateDetails((prev: any) => {
      return {
        ...prev,
        positionDetails: {
          ...prev.positionDetails,
          offeredJobPosition: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };

  const handleProgressChange = (data: any) => {
    setInputDetailsError((prevErrors) => ({
      ...prevErrors,
      jobprogressError: "",
    }));
    setCandidateDetails((prev: any) => {
      return {
        ...prev,
        positionDetails: {
          ...prev.positionDetails,
          progress: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };

  const handleDepartmentChange = (data: any) => {
    setCandidateDetails((prev: any) => {
      return {
        ...prev,
        positionDetails: {
          ...prev.positionDetails,
          department: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };

  const handleProposedJoiningDateChange = (data: any) => {
    if (data !== null) {
      setCandidateDetails((prev: any) => {
        return {
          ...prev,
          positionDetails: {
            ...prev.positionDetails,
            proposedJoiningDate: data,
          },
        };
      });
    } else {
      setCandidateDetails((prev: any) => {
        return {
          ...prev,
          positionDetails: {
            ...prev.positionDetails,
            proposedJoiningDate: null,
          },
        };
      });
    }
  };

  const handleSourcesChange = (data: any) => {
    setCandidateDetails((prev: any) => {
      return {
        ...prev,
        otherDetails: {
          ...prev.otherDetails,
          sources: {
            value: data?.value,
            label: data?.label,
          },
        },
      };
    });
  };

  const handleAddAnotherDetails = () => {
    let temp: any = JSON.parse(JSON.stringify(interviewerInputDetails));
    temp.push(...JSON.parse(JSON.stringify(interviewAddMoreDetailsInput)));
    setInterviewerInputDetails(temp);
  };

  const handleRemoveRow = (index: any) => {
    let temp = JSON.parse(JSON.stringify(interviewerInputDetails));
    temp.splice(index, 1);
    setInterviewerInputDetails(temp);
  };

  const handleInterviewsInputDetailsChange = (
    dataKey: any,
    value: any,
    index: number
  ) => {
    let temp = JSON.parse(JSON.stringify(interviewerInputDetails));
    if (value === "Invalid date") {
      temp[index][dataKey] = "";
    } else if (dataKey === "interviewers") {
      temp[index][dataKey] = {
        value: value?.value,
        label: value?.label?.split("%")[0],
      };
      temp[index]["interviewersError"] = "";
    } else if (dataKey === "interviewDateAndTime") {
      temp[index][dataKey] = value;
      temp[index]["interviewDateAndTimeError"] = "";
    } else {
      temp[index][dataKey] = value;
    }
    setInterviewerInputDetails([...temp]);
  };

  const handleInterviewFormDetailsChange = (dataKey: string, value: any) => {
    setCandidateDetails((prev: any) => ({
      ...prev,
      interviewDetails: {
        ...prev.interviewDetails,
        [dataKey]:
          value == "Invalid date"
            ? ""
            : dataKey === "phoneScreener"
              ? {
                value: value?.value,
                label: value?.label?.split("%")[0],
              }
              : value,
      },
    }));

    if (dataKey == "applicationDate") {
      setInputDetailsError((prevErrors) => ({
        ...prevErrors,
        applicationDateError:
          dataKey == "applicationDate" &&
            (value !== null || value !== "Invalid date")
            ? ""
            : "Application Date Required",
      }));
    } else if (dataKey === "phoneScreener") {
      setInputDetailsError((prevErrors) => ({
        ...prevErrors,
        phoneScreenerError: value?.value ? "" : "Phone Screener Required",
      }));
    } else if (dataKey == "phoneScreeningDateAndTime") {
      setInputDetailsError((prevErrors) => ({
        ...prevErrors,
        phoneScreeningDateAndTimeError:
          value !== null || value !== "Invalid date"
            ? ""
            : "Phone Screening Date & Time Required",
      }));
    }
  };
  const handleSubmit = () => {
    const errors: any = {};
    if (!candidateDetails?.applicantDetails?.name?.trim()) {
      errors.nameError = "Name Required";
    }
    if (!candidateDetails?.applicantDetails?.email?.trim()) {
      errors.emailError = "Email Required";
    }
    if (!candidateDetails?.applicantDetails?.phoneNumber) {
      errors.phoneNumberError = "Phone Number Required";
    }
    if (!candidateDetails?.applicantDetails?.yearsOfExperience) {
      errors.yearsOfExperienceError = "Years of Experience Required";
    }
    if (!candidateDetails?.positionDetails?.progress?.value) {
      errors.jobprogressError = "Job Progress Required";
    }
    if (!candidateDetails?.positionDetails?.jobLocation?.value) {
      errors.jobLocationError = "Job Location Required";
    }
    if (!candidateDetails?.positionDetails?.jobPosition?.value) {
      errors.jobPositionError = "Job Position Required";
    }
    if (!candidateDetails?.interviewDetails?.applicationDate) {
      errors.applicationDateError = !candidateDetails?.interviewDetails
        ?.applicationDate
        ? "Application Date Required"
        : "";
    }
    setInterviewerInputDetails([...interviewerInputDetails]);
    if (Object.keys(errors).length > 0) {
      toast.error("Please Fill Required Fields!", {
        duration: 2000,
      });

      setInputDetailsError(errors);
    } else {
      const finalData = {
        candidateDetails,
      };
      if (
        candidateDetails?.positionDetails?.progress?.value ===
        "Offer Accepted" &&
        !singleRecruitmentTrackerList?.is_user_created
      ) {
        setConfirmedAllUsers(true);
      } else {
        handleRecruitmentTrackerSubmit?.(finalData);
      }
    }
  };

  function handleUserAndRecruitmentTrackerSubmit(data: string) {
    const finalData = {
      candidateDetails: {
        ...candidateDetails,
        is_user_created: data === "0" ? false : true,
      },
    };
    let finaAllUsersObj = {
      ...allUserDataForm,
      user_details: {
        ...allUserDataForm?.user_details,
        current_address: {
          ...allUserDataForm?.user_details?.current_address,
          city: "Select",
          state: "Select",
          postal_code: "",
          country: "",
        },
        permanent_address: {
          address_line1: "",
          address_line2: "",
          city: "Select",
          state: "Select",
          postal_code: "",
          country: "Select",
        },
        contact_details: {
          ...allUserDataForm?.user_details?.contact_details,
          personal_email_id: candidateDetails?.applicantDetails?.email,
        },
        online_presence: {
          ...allUserDataForm?.user_details?.online_presence,
          linkedin_profile: candidateDetails?.applicantDetails?.linkedinProfile,
        },
      },
      hr_settings: {
        ...allUserDataForm.hr_settings,
        work_details: {
          ...allUserDataForm.hr_settings?.work_details,
          user_branch: candidateDetails?.positionDetails?.jobLocation?.value,
        },
      },
      job_details: [
        {
          is_default: true,
          job_info: {
            employee_id: null,
            job_title: "",
            department: {
              id: null,
              name: "",
            },
            designation: {
              id: null,
              name: "",
            },
            start_date: null,
            end_date: null,
            total_experience: "",
            rejoin_date: null,
            date_of_notice: null,
            date_of_relieve: null,
            date_of_conformation: null,
            client: null,
          },
          reporting_details: {
            it_assets_assigned: "",
            reporting_person: null,
            coach: null,
          },
          file_attachment: [],
          emailer_settings: [],
        },
      ],
      payroll_settings: {
        identification_details: {
          passport_number: "",
          passport_expiry: null,
          adhar_number: "",
          pan: "",
          uan_number: "",
          entity_name: "",
        },
        bank_account_details: [
          {
            bank_name: "",
            branch_name: "",
            bank_account_number: "",
            ifsc_code: "",
            account_type: "",
          },
        ],
        hourly_charge: "",
        standard_hour: "",
      },
      user_settings: {
        is_track_aproved_entries: false,
        total_target_entries: null,
        is_disable_user: false,
      },
    };
    if (data !== "0") {
      let finalAllUserData = { profileData: { ...finaAllUsersObj }, token };
      dispatchAddUser(finalAllUserData);
    }
    handleRecruitmentTrackerSubmit?.(finalData);
    handleAllUser();
  }

  const handleAllUser = () => {
    setConfirmedAllUsers(!confirmedAllUsers);
  };
  const handleApproval = () => {
    setSendApprovalsModal(!sendApprovalsModal);
  };

  useDebounce(
    () => {
      const emailValidation = !isEmailValid(
        allUserDataForm?.user_details?.basic_details?.email_id
      );
      const stcoEmailValidation = !isStcoEmailValid(
        allUserDataForm?.user_details?.basic_details?.email_id
      );
      if (
        (emailValidation || stcoEmailValidation) &&
        allUserDataForm?.user_details?.basic_details?.email_id?.length
      ) {
        setInputDetailsError((prv) => ({
          ...prv,
          stcoEmailError: "Email Should be end with @stco.co.in OR @akssai.com",
        }));
      } else {
        setInputDetailsError((prv) => ({
          ...prv,
          stcoEmailError: "",
        }));
      }

      if (allUserDataForm?.user_details?.basic_details?.email_id) {
        const finalData = {
          token,
          operation: "add",
          email: allUserDataForm?.user_details?.basic_details?.email_id,
        };
        dispatchCheckUniqueEmailAction(finalData);
      }
    },
    500,
    [allUserDataForm?.user_details?.basic_details?.email_id]
  );

  const handleStcoEmailChange = (email: string) => {
    setInputDetailsError((prv) => ({
      ...prv,
      stcoEmailError: "",
    }));

    setAllUserDataForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          basic_details: {
            ...prv.user_details.basic_details,
            email_id: email,
          },
        },
      };
    });
  };

  const handleErrorModal = () => {
    if (
      hrmsSuccess === 1 &&
      hrmsMessage === "Recruitment approval request has been sent successfully!"
    ) {
      toast.success(
        "Recruitment approval request has been sent successfully!",
        {
          duration: 2000,
        }
      );
      dispatchResetHrmsSuccess();
      dispatchResetHrmsMessage();

      dispatchResetApprovalList();
      if (token && isEdit && isPendingHRMSInterviewApprovals) {
        const finaData = {
          hrms_id: singleRecruitmentTrackerList?._id,
          token,
          type: "hrms",
          sort_by: "approved_at",
          sorting_order: "asc",
        };
        dispatchApprovalListAction(finaData);
      }
    }
  };
  return (
    <>
      <div className="">
        <p style={{ fontSize: "20px", fontWeight: "500" }} className="mb-0">
          Candidate Application Form
        </p>
        <p
          style={{
            fontSize: "14px",
            color: "#6e7491",
            fontWeight: "500",
            marginBottom: "24px",
          }}
        >
          {" "}
          {isEdit
            ? "Edit candidate details"
            : "Fill form below to add candidate details"}
        </p>
        <CandidateInformation
          data={candidateDetails?.applicantDetails}
          setCandidateDetails={setCandidateDetails}
          isEdit
          applicantDetails={candidateDetails?.applicantDetails}
          inputDetailsError={inputDetailsError}
          handleBasicDetailsInput={handleBasicDetailsInput}
          handleOpenPreview={handleOpenPreview}
          handleResumeToggleUploadModal={handleResumeToggleUploadModal}
          handleDeleteResume={handleDeleteResume}
          isEditData={isEdit}
          candidateDetails={candidateDetails}
          finalSkillList={finalSkillList}
          setSkillsOffset={setSkillsOffset}
          setSkillsText={setSkillsText}
          branchFetching={branchFetching}
          setQualificationText={setQualificationText}
          setQualificationOffset={setQualificationOffset}
          skillsText={skillsText}
          limit={limit}
          qualificationText={qualificationText}
          finalQualificationList={finalQualificationList}
          recruitmentTrackerUniqueEmailFetching={
            recruitmentTrackerUniqueEmailFetching
          }
          recruitmentTrackerUniqueEmailMessage={
            recruitmentTrackerUniqueEmailMessage
          }
          recruitmentTrackerUniqueMobileFetching={
            recruitmentTrackerUniqueMobileFetching
          }
          recruitmentTrackerUniqueMobileMessage={
            recruitmentTrackerUniqueMobileMessage
          }
        />
        <PositionDetails
          positionDetails={candidateDetails?.positionDetails}
          finalBranchDataList={finalBranchDataList}
          handleBranceDetailsChange={handleBranceDetailsChange}
          branchFetching={branchFetching}
          branchText={branchText}
          setBranchOffset={setBranchOffset}
          limit={limit}
          setBranchText={setBranchText}
          handleProgressChange={handleProgressChange}
          setRecruiterOffset={setRecruiterOffset}
          recruiterLimit={recruiterLimit}
          recruiterOffset={recruiterOffset}
          recruiterText={recruiterText}
          finalRecruiterList={finalRecruiterList}
          setRecruiterText={setRecruiterText}
          userFetching={userFetching}
          handleRecruiterDropdownChange={handleRecruiterDropdownChange}
          jobPositionFetching={jobPositionFetching}
          finalJobPositionList={finalJobPositionList}
          setJobPositionOffset={setJobPositionOffset}
          jobPositionText={jobPositionText}
          setJobPositionText={setJobPositionText}
          handleJobPositionChange={handleJobPositionChange}
          handleOfferedJobPosition={handleOfferedJobPosition}
          inputDetailsError={inputDetailsError}
          finalDepartmentList={finalDepartmentList}
          departmentText={departmentText}
          setDepartmentText={setDepartmentText}
          setDepartmentOffset={setDepartmentOffset}
          handleDepartmentChange={handleDepartmentChange}
          handleProposedJoiningDateChange={handleProposedJoiningDateChange}
        />
        <InterViewDetails
          interviewDetails={candidateDetails?.interviewDetails}
          setRecruiterOffset={setRecruiterOffset}
          recruiterLimit={recruiterLimit}
          recruiterOffset={recruiterOffset}
          recruiterText={recruiterText}
          finalRecruiterList={finalRecruiterList}
          setRecruiterText={setRecruiterText}
          userFetching={userFetching}
          handleRemoveRow={handleRemoveRow}
          interviewerInputDetails={interviewerInputDetails}
          handleAddAnotherDetails={handleAddAnotherDetails}
          handleInterviewsInputDetailsChange={
            handleInterviewsInputDetailsChange
          }
          handleInterviewFormDetailsChange={handleInterviewFormDetailsChange}
          inputDetailsError={inputDetailsError}
        />
        <SalaryDetails
          salaryDetails={candidateDetails?.salary_details}
          inputDetailsError={inputDetailsError}
          handleBasicDetailsInput={handleBasicDetailsInput}
        />
        <OtherDetails
          OtherDetails={candidateDetails?.otherDetails}
          inputDetailsError={inputDetailsError}
          handleBasicDetailsInput={handleBasicDetailsInput}
          finalReferedByList={finalReferedByList}
          userFetching={userFetching}
          referedByText={referedByText}
          referedByOffset={referedByOffset}
          setReferedByOffset={setReferedByOffset}
          setReferedByText={setReferedByText}
          referedByLimit={referedByLimit}
          handleReferedByDropdownChange={handleReferedByDropdownChange}
          handleSourcesChange={handleSourcesChange}
        />
        {pathname?.includes("edit") && (
          <ApprovalsDeatils
            data={approvalList}
            sendApprovalsModal={sendApprovalsModal}
            setSendApprovalsModal={setSendApprovalsModal}
          />
        )}
        <hr />
        <div className="row mt-5">
          <div className="col-md-12 text-right">
            <button
              className="btn"
              style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
              onClick={() => handleGoBack?.()}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
            // disabled={isSaveDisabled}
            >
              {isEdit ? "Save Changes" : "Save"}
            </button>
          </div>
        </div>
      </div>
      {confirmedAllUsers && (
        <ConfirmAllUserModal
          isOpen={confirmedAllUsers}
          toggle={handleAllUser}
          inputDetailsError={inputDetailsError}
          emailFetching={emailFetching}
          isEmail={isEmail}
          emailMessage={emailMessage}
          data={allUserDataForm}
          handleStcoEmailChange={handleStcoEmailChange}
          setInputDetailsError={setInputDetailsError}
          handleUserAndRecruitmentTrackerSubmit={
            handleUserAndRecruitmentTrackerSubmit
          }
        />
      )}

      {showResumeUploadModal && (
        <SingleUploadWithApi
          modal={showResumeUploadModal}
          toggleModal={handleResumeToggleUploadModal}
          token={token}
          isDraggableModal
          acceptedFiles={
            "image/png, application/pdf, image/jpeg, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          }
          maxFileSize={1000000}
          supportedFiles="PNG, JPEG, PDF and Doc."
        />
      )}

      {showImagePreview && (
        <SinglePreviewWithApi
          resetImageUrl={handlePreviewImageModal}
          imageDetails={previewData}
          token={token}
          type={"finaccrm"}
        />
      )}
      {sendApprovalsModal && (
        <SendApprovalModal
          isOpen={sendApprovalsModal}
          setSendApprovalsModal={setSendApprovalsModal}
          data={approvalList}
          id={singleRecruitmentTrackerList?._id}
          handleApproval={handleApproval}
        />
      )}
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.auth.success,
  hrmsMessage: state.hrms.message,
  hrmsSuccess: state.hrms.success,
  statusCode: state.auth.statusCode,
  masterDataSuccess: state.masterData.success,
  masterDataStatusCode: state.masterData.statusCode,
  finacUser: state.auth.finacUsersList,
  totalUserCount: state.auth.totalUserCount,
  userFetching: state.auth.fetching,
  branchFetching: state.masterData.fetching,
  branchDataList: state.masterData.masterDataListing,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
  loginData: state.auth.loginData,
  fetching: state.hrms.addEditFetching,
  openPoisitionList: state.hrms.openPoisitionList,
  openPositionTotalCount: state.hrms.openPositionTotalCount,
  jobPositionFetching: state.hrms.fetching,
  error: state.hrms.error,
  emailFetching: state.auth.emailFetching,
  isEmail: state.auth.isEmail,
  emailMessage: state.auth.emailMessage,
  recruitmentTrackerUniqueEmailFetching:
    state.auth.recruitmentTrackerUniqueEmailFetching,
  recruitmentTrackerUniqueEmailMessage:
    state.auth.recruitmentTrackerUniqueEmailMessage,
  recruitmentTrackerUniqueMobileFetching:
    state.auth.recruitmentTrackerUniqueMobileFetching,
  recruitmentTrackerUniqueMobileMessage:
    state.auth.recruitmentTrackerUniqueMobileMessage,
  approvalList: state.hrms.approvalList,
  skillMasterDataList: state.masterData.skillMasterDataList,
  skillsMasterDataTotalCount: state.masterData.skillsMasterDataTotalCount,
  qualificationMasterDataList: state.masterData.qualificationMasterDataList,
  qualificationMasterDataTotalCount:
    state.masterData.qualificationMasterDataTotalCount,
  userDepartmentList: state.masterData.userDepartmentList,
  userDepartmentTotalCount: state.masterData.userDepartmentTotalCount,
  fileUploadData: state.clientSettings.multipleFileUploadData,
});
const dispatchStateToProps = (dispatch: any) => ({
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchGetAllMasterDataBranchListAction: (
    data: GetAllMasterDataBranchPayloadType
  ) => {
    dispatch(getAllMasterDataBranchAction(data));
  },
  dispatchResetFinacClientUsersList: () => dispatch(resetFinacClientUsersList),
  dispatchGetRecruitmentModuleOpenPositionAction: (data: any) =>
    dispatch(getRecruitmentModuleOpenPositionAction(data)),
  dispatchResetRecruitmentTrackerList: () =>
    dispatch(resetRecruitmentTrackerList()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetHrmsSuccess: () => dispatch(resetHrmsSuccess()),
  dispatchResetHrmsMessage: () => dispatch(resetHrmsMessage()),
  dispatchResetHrmsError: () => dispatch(resetHrmsError()),
  dispatchResetEmailFetching: () => dispatch(resetEmailFetching()),
  dispatchResetEmailMessage: () => dispatch(resetEmailMessage()),
  dispatchResetRecruitmentTrackerUniqueEmailMessage: () =>
    dispatch(resetRecruitmentTrackerUniqueEmailMessage()),
  dispatchResetRecruitmentTrackerUniqueMobileMessage: () =>
    dispatch(resetRecruitmentTrackerUniqueMobileMessage()),
  dispatchCheckUniqueEmailAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => dispatch(checkUniqueEmailAction(data)),
  dispatcCheckRecruitmentTrackerUniqueEmailAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => dispatch(checkRecruitmentTrackerUniqueEmailAction(data)),
  dispatchCheckRecruitmentTrackerUniqueMobileNoAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => dispatch(checkRecruitmentTrackerUniqueMobileNoAction(data)),
  dispatchAddUser: (data: any) => dispatch(addUserPofile(data)),
  dispatchApprovalListAction: (data: ApprovalListPayloadType) =>
    dispatch(getApprovalListAction(data)),
  dispatchResetApprovalList: () => dispatch(resetApprovalList()),
  dispatchGetMasterDataSkillsModuleAction: (
    data: GetMasterDataListPayloadType
  ) => dispatch(getMasterDataSkillsModuleAction(data)),
  dispatchResetSkillMasterDataList: () => dispatch(resetSkillMasterDataList()),
  dispatchResetSkillsMasterDataTotalCount: () =>
    dispatch(resetSkillsMasterDataTotalCount()),
  dispatchGetMasterDataQualificationModuleAction: (
    data: GetMasterDataListPayloadType
  ) => dispatch(getMasterDataQualificationModuleAction(data)),
  dispatchResetQualificationMasterDataList: () =>
    dispatch(resetQualificationMasterDataList()),
  dispatchResetQualificationMasterDataTotalCount: () =>
    dispatch(resetQualificationMasterDataTotalCount()),
  dispatchGetMasterDataUsersDepartmentAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataUsersDepartmentAction(data)),
  dispatchResetUserDepartmentList: () => dispatch(resetUserDepartmentList()),
  dispatchResetresetUserDepartmentTotalCount: () =>
    dispatch(resetUserDepartmentTotalCount()),
  dispatchResetFileUploadFetching: () =>
    dispatch(resetMultipleFileUploadFetching()),

  dispatchResetFileUploadData: () => dispatch(resetMultipleFileUploadData()),

  dispatchResetFileUploadSuccess: () =>
    dispatch(resetMultipleFileUploadSuccess()),

  dispatchResetFileUploadError: () => dispatch(resetMultipleFileUploadError()),
});
export default connect(
  mapStateToProps,
  dispatchStateToProps
)(CandidateApplicationForm);
